// Copyright 2025 Sorama B.V.
import { bindable, computedFrom, customElement } from "aurelia-framework";

@customElement("linear-progress")
export class LinearProgress {
    /** Text shown below the progress bar on the left (E.g. "Downloading...") */
    @bindable public text = "";
    /** e.g., current size in MB*/
    @bindable
    public currentValue: number | null = null;
    /** Total value that represents 100% (e.g., total size in MB, total number of measurements) */
    @bindable
    public totalValue: number | null = null;
    /** Unit of measurement for the current and total values (e.g., "MB", "Measurements") */
    @bindable public unit = "";

    @computedFrom("currentValue", "totalValue", "unit")
    get hasRightText(): boolean {
        return this.currentValue !== null && this.totalValue !== null && this.unit !== "";
    }
    /**
     * Automatically computes the progress percentage based on current and total values.
     */
    @computedFrom("currentValue", "totalValue")
    public get progressPercentage(): number {
        if (this.totalValue === null || this.totalValue <= 0 || this.currentValue === null || this.currentValue < 0) {
            return 0;
        }
        // Ensure percentage doesn't exceed 100
        return Math.min((this.currentValue / this.totalValue) * 100, 100);
    }
}
